import { FETCH_BLOG_LIMIT_SUCCEEDED, FETCH_BLOG_POST_LIMIT_SUCCEEDED, FETCH_MLANG_BLOG_POST_LIMIT_SUCCEEDED } from '../actions/actionTypes';
const initialState = {
  blogLimit: null,
  blogQuantityUsed: 0,
  blogPostLimit: null,
  blogPostQuantityUsed: 0,
  hasExceededContentTypeLimit: false,
  mlangPostLimit: null,
  mlangPostQuantityUsed: 0
};
const blogLimitReducer = (state = initialState, {
  payload,
  type
}) => {
  switch (type) {
    case FETCH_BLOG_LIMIT_SUCCEEDED:
      {
        if (payload && payload.limit) {
          return Object.assign({}, state, {
            blogLimit: payload.limit,
            blogQuantityUsed: payload.quantityUsed,
            hasExceededContentTypeLimit: state.hasExceededContentTypeLimit || payload.quantityUsed > payload.limit
          });
        }
        return state;
      }
    case FETCH_BLOG_POST_LIMIT_SUCCEEDED:
      {
        if (payload && payload.limit) {
          return Object.assign({}, state, {
            blogPostLimit: payload.limit,
            blogPostQuantityUsed: payload.quantityUsed,
            hasExceededContentTypeLimit: state.hasExceededContentTypeLimit || payload.quantityUsed > payload.limit
          });
        }
        return state;
      }
    case FETCH_MLANG_BLOG_POST_LIMIT_SUCCEEDED:
      {
        if (payload && payload.limit) {
          return Object.assign({}, state, {
            mlangPostLimit: payload.limit,
            mlangPostQuantityUsed: payload.quantityUsed
          });
        }
        return state;
      }
    default:
      return state;
  }
};
export default blogLimitReducer;